import api from "../lib/api";

// Uses the shared axios instance rather than its own. The previous private
// client read REACT_APP_API_URL with a "http://localhost:3000/api" fallback, so
// once deployed My Assets and Raise Query called the *visitor's* machine (and
// a base without "/api" produced "/assets/..." paths). The shared instance
// resolves the deployed API, attaches the token and handles 401s.
const assetService = {
  getMyAssets: (params = {}) =>
    api.get("/assets/my", { params }).then((res) => res.data),

  getAssetSummary: (params = {}) =>
    api.get("/assets/summary", { params }).then((res) => res.data),

  getAssetById: (id) => api.get(`/assets/${id}`).then((res) => res.data),

  raiseAssetQuery: ({ assetId, message }) =>
    api
      .post(`/assets/${assetId}/query`, { message })
      .then((res) => res.data),
};

export default assetService;
